var map = {
	"./467dcfdf-ac73-4ec4-bcce-c849d1ca5ba7-1684908108505.jpg": 4750,
	"./b1834bd9-9ab3-4180-aabc-78e51c2fa133-1684906464952.jpg": 3906,
	"./sample": 7156,
	"./sample.jsx": 7156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6209;